import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import AboutPage from "./pages/AboutPage";
import HealthBenefitsPage from "./pages/HealthBenefitsPage";
import AthleticPerformancePage from "./pages/AthleticPerformancePage";
import FAQPage from "./pages/FAQPage";
import PressPage from "./pages/PressPage";
import AnalysisPage from "./pages/AnalysisPage";
import WaitlistPage from "./pages/WaitlistPage";
import ResourcesPage from "./pages/ResourcesPage";
import TheEdgePage from "./pages/TheEdgePage";
import { Toaster } from "./components/ui/toaster";

function ScrollToTop() {
  const { pathname } = window.location;
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#f4f0e6]">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/health-benefits" element={<HealthBenefitsPage />} />
            <Route path="/athletic-performance" element={<TheEdgePage />} />
            <Route path="/the-edge" element={<TheEdgePage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/press" element={<PressPage />} />
            <Route path="/analysis" element={<AnalysisPage />} />
            <Route path="/waitlist" element={<WaitlistPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
